import $S from 'scriptjs'

export const loadScripts = scriptsLoaded => {
  if (scriptsLoaded) {
    return true
  } else {
    return new Promise(resolve => {
      $S(
        'https://cdnjs.cloudflare.com/ajax/libs/react/15.6.1/react.min.js',
        () => {
          $S(
            'https://cdnjs.cloudflare.com/ajax/libs/react/15.6.1/react-dom.min.js',
            () => {
              $S(
                'https://cdnjs.cloudflare.com/ajax/libs/ol3/4.1.0/ol.js',
                () => {
                  $S(
                    'https://streetsmart.cyclomedia.com/api/v17.3/StreetSmartApi.js',
                    () => {
                      resolve(true)
                    }
                  )
                }
              )
            }
          )
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Cyclomedia/CycloDependencies/utils.js